import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Gender } from '../models/gender.model';

@Injectable({
  providedIn: 'root'
})
export class GenderService {

  constructor(private httpClient: HttpClient) { }

  getGenders() : Observable<Gender[]> {
    return this.httpClient.get<Gender[]>('assets/components/gender/gender.json').pipe(
      map(data => data)
    );
  }
}
